import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./map.html';
import styles from './PaQuickQuoteLocationMap-hashed.scss';
import controller from './PaQuickQuoteLocationMapCtrl';

export default {
    template: cssUtil.hashTemplate(template, styles),
    controller: controller,
    bindings: {
        mapName: '@',
        coords: '<',
        getDeviceLocation: '&',
        address: '<',
        defaultLocation: '<'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/quickquote/pa/directives/LocationMap/index.js
// module id = 2191
// module chunks = 0